import { css } from '@linaria/atomic';

export const boolListHorizontal = css`
  display: flex;
  gap: 16px;
`;
